export default "__VITE_ASSET__BYJLBcWV__"